// extracted by mini-css-extract-plugin
export default {"breadcrumbsContainer":"Breadcrumbs_breadcrumbsContainer__nY-cc","arrowSeparator":"Breadcrumbs_arrowSeparator__kW4aa"};